"use client";

import React, { useRef, useState } from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { ArrowLeft } from "lucide-react";
export default function FromIdeaToShelf() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1,
    once: true
  });
  const bookContainerRef = useRef<HTMLDivElement>(null);
  const [tilt, setTilt] = useState({
    x: 0,
    y: 0
  });
  const handleMouseMove = (e: React.MouseEvent<HTMLDivElement>) => {
    if (!bookContainerRef.current) return;
    const rect = bookContainerRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    const centerX = rect.width / 2;
    const centerY = rect.height / 2;
    const maxTilt = 12;
    const tiltX = (centerY - y) / centerY * maxTilt;
    const tiltY = (x - centerX) / centerX * maxTilt;
    setTilt({
      x: tiltX,
      y: tiltY
    });
  };
  const handleMouseLeave = () => {
    setTilt({
      x: 0,
      y: 0
    });
  };
  return <section data-section-id="228384" id="a-taste-of-paradise-in-saranda" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden py-24">
      {}
      <div className="absolute inset-0 opacity-[0.05] pointer-events-none bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/saranda_coastline_pattern.png)] bg-cover bg-center mix-blend-multiply" aria-hidden="true" />

      {}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-secondary/30 rounded-lg blur-[120px] pointer-events-none" />

      <div className="container mx-auto px-4 relative z-10">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          
          {}
          <div ref={textRef} className={`transition-all duration-[1200ms] ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-16"}`}>
            <h1 className="text-5xl md:text-6xl lg:text-8xl font-default font-bold leading-[1.1] tracking-tighter mb-8 text-foreground">
              Frozen Paradise by Ksanti - Ice Cream, Cocktails & Desserts in Saranda
            </h1>
            
            <p className="text-lg md:text-xl text-muted-foreground mb-10 max-w-xl leading-relaxed font-default">
              Experience the sweet side of Saranda at Frozen Paradise. From artisanal gelato to signature sunset cocktails, we craft every moment with Mediterranean soul.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4">
              <Button asChild size="lg" className="h-14 px-8 text-lg rounded-md shadow-lg bg-primary hover:bg-primary/90 text-primary-foreground transition-all">
                <Link to="#">
                  View Our Menu
                  <ArrowLeft className="mr-2 h-5 w-5 rotate-180" />
                </Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-14 px-8 text-lg rounded-md border-primary/20 hover:bg-primary/5 text-primary font-default">
                <Link to="/HomePage">Our Story</Link>
              </Button>
            </div>
          </div>

          {}
          <div className="relative w-full max-w-[450px] mx-auto aspect-[3/4] perspective-[1200px] cursor-pointer group" ref={bookContainerRef} onMouseMove={handleMouseMove} onMouseLeave={handleMouseLeave}>
            <div className="w-full h-full transition-transform duration-300 ease-out preserve-3d relative" style={{
            transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)`,
            transformStyle: "preserve-3d"
          }}>
              {}
              <div className="absolute -inset-4 bg-primary/20 blur-2xl rounded-lg -z-10 transform translate-y-8 transition-opacity duration-300 group-hover:opacity-70" />
              
              {}
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/signature_cocktail_sunset.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/signature_cocktail_sunset.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1678745/img/signature_cocktail_sunset.png-wvc-sizes" alt="Signature Cocktail at Sunset" className="w-full h-full object-cover shadow-xl rounded-lg border-4 border-white/50 backdrop-blur-sm" style={{
              backfaceVisibility: "hidden"
            }} loading="lazy" />

              {}
              <Link to="/" className="absolute top-4 right-4 z-20 block w-32 md:w-36 transition-transform hover:scale-105">
                <img src="https://frozenparadisebyksanti.com/wp-content/uploads/2026/05/cropped-cropped-cropped-frozen_paradise_logo-6.png" alt="Frozen Paradise Logo" className="w-full h-auto shadow-lg opacity-95 rounded-lg" loading="lazy" />
              </Link>
              
              {}
              <div className="absolute top-0 right-0 h-full w-[20px] bg-gradient-to-r from-secondary to-background origin-right transform rotateY-90 rounded-r-md" style={{
              transform: "rotateY(90deg) translateZ(1px)",
              right: "-20px"
            }} />
            </div>
          </div>
          
        </div>
      </div>
    </section>;
}